<div class="img-bg contact-us-organizer">
    <div class="col-md-12 contactus">Contact Us</div>
    <div class="gr-bg">
        <div class="wt-bg">
            <div class="mi-img">
                <img *ngIf="isMobileView" src="../../../assets/icon/image 67.png">
                <img *ngIf="!isMobileView" src="../../../assets/authImg/image67.svg">
            </div>
            <div class="text">
                <div style="display: flex;">
                    <div class="in-ca">customerservice<div>@officialgamedaymeals.com</div>
                    </div>
                </div>

                <div class="email-btn"><a href="mailto:customerservice@officialgamedaymeals.com"><button
                            class="email-button">Email
                            Us</button></a></div>
            </div>
        </div>
    </div>
</div>